import { render, staticRenderFns } from "./VpayChargeApplyOffline.vue?vue&type=template&id=0a896f20&scoped=true"
import script from "./VpayChargeApplyOffline.vue?vue&type=script&lang=js"
export * from "./VpayChargeApplyOffline.vue?vue&type=script&lang=js"
import style0 from "./VpayChargeApplyOffline.vue?vue&type=style&index=0&id=0a896f20&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a896f20",
  null
  
)

export default component.exports